import { PackageQuote, SelectQuoteForOpportunityMutationVariables } from '@graphql';

type TransformSelectQuoteForOpportunityInput = {
  selectedQuotes: PackageQuote[];
  isCashPayment?: boolean;
};

export const transformSelectQuoteForOpportunityInput = ({
  selectedQuotes,
  isCashPayment = false,
}: TransformSelectQuoteForOpportunityInput): SelectQuoteForOpportunityMutationVariables | null => {
  const [mainQuote, ...relatedQuotes] = selectedQuotes;
  const opportunityId = mainQuote.opportunity?.id;

  if (!mainQuote.trackingId || !opportunityId) {
    return null;
  }

  const relatedQuotesWithTrackingIds = relatedQuotes.reduce<string[]>((acc, quote) => {
    if (quote.trackingId) {
      acc.push(quote.trackingId);
    }
    return acc;
  }, []);

  return {
    input: {
      opportunityId,
      trackingIds: [mainQuote.trackingId, ...relatedQuotesWithTrackingIds],
      isCashPayment,
    },
  };
};
